module.exports = __webpack_public_path__ + "static/media/unauthorized_mobile.5d2d4e16.png";